import React from 'react';

export default function PitchforkSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      {/* Handle */}
      <rect x="18.5" y="14" width="3" height="24" rx="1.5" fill="#A67C52" />
      <rect x="19" y="14.5" width="2" height="23" rx="1" fill="#C49A6C" />
      {/* Handle wrap detail */}
      <line x1="18.5" y1="30" x2="21.5" y2="29" stroke="#8D6E63" strokeWidth="0.8" opacity="0.5" />
      <line x1="18.5" y1="32" x2="21.5" y2="31" stroke="#8D6E63" strokeWidth="0.8" opacity="0.5" />
      <line x1="18.5" y1="34" x2="21.5" y2="33" stroke="#8D6E63" strokeWidth="0.8" opacity="0.5" />
      {/* Fork head base */}
      <rect x="12" y="12" width="16" height="4" rx="2" fill="#78909C" />
      <rect x="13" y="12.5" width="14" height="3" rx="1.5" fill="#90A4AE" />
      {/* Left tine */}
      <rect x="13" y="2" width="2.5" height="12" rx="1.25" fill="#78909C" />
      <rect x="13.5" y="2.5" width="1.5" height="11" rx="0.75" fill="#90A4AE" />
      {/* Center tine */}
      <rect x="18.75" y="2" width="2.5" height="12" rx="1.25" fill="#78909C" />
      <rect x="19.25" y="2.5" width="1.5" height="11" rx="0.75" fill="#90A4AE" />
      {/* Right tine */}
      <rect x="24.5" y="2" width="2.5" height="12" rx="1.25" fill="#78909C" />
      <rect x="25" y="2.5" width="1.5" height="11" rx="0.75" fill="#90A4AE" />
      {/* Tine tips - pointed */}
      <path d="M13 3L14.25 0.5L15.5 3" fill="#78909C" />
      <path d="M18.75 3L20 0.5L21.25 3" fill="#78909C" />
      <path d="M24.5 3L25.75 0.5L27 3" fill="#78909C" />
      {/* Shine on tines */}
      <line x1="14" y1="4" x2="14" y2="10" stroke="white" strokeWidth="0.6" strokeLinecap="round" opacity="0.2" />
      <line x1="19.75" y1="4" x2="19.75" y2="10" stroke="white" strokeWidth="0.6" strokeLinecap="round" opacity="0.2" />
      <line x1="25.5" y1="4" x2="25.5" y2="10" stroke="white" strokeWidth="0.6" strokeLinecap="round" opacity="0.2" />
    </svg>
  );
}
